if (!customElements.get("secondary-nav")) {
  customElements.define(
    "secondary-nav",
    class SecondaryNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.scrollableElement = this.querySelector(
          ".secondary-navigation__ul",
        );
        this.container = this.querySelector(".secondary-navigation");
        this.swiperEl = this.querySelector('.swiper');
        this.dataCenterSlides = this.dataset.centerSlides === '';
        this.keepPosition = this.hasAttribute('data-keep-position');

        this.handleLinkClick = (event) => {
          if (!this.keepPosition) return;

          const selectedLink = event.target.closest('.secondary-navigation__link');
          if (!selectedLink || !this.contains(selectedLink)) return;

          this.querySelectorAll('.secondary-navigation__swiper-slide--active').forEach((slide) => {
            slide.classList.remove('secondary-navigation__swiper-slide--active');
          });
          this.querySelectorAll('.secondary-navigation__link--active').forEach((link) => {
            link.classList.remove('secondary-navigation__link--active');
          });

          selectedLink.classList.add('secondary-navigation__link--active');
          selectedLink.closest('.secondary-navigation__swiper-slide')?.classList.add('secondary-navigation__swiper-slide--active');
        };

        this.addEventListener('click', this.handleLinkClick);

        if (window.Swiper) {
          this.initSwiper();
        } else {
          window.addEventListener('load', () => this.initSwiper());
          setTimeout(() => this.initSwiper(), 500);
        }
      }

      initSwiper(){
        if (this.swiper) return;
        const SwiperClass = window.Swiper;
        if (!SwiperClass || !this.swiperEl) return;

        const scrollToActiveSlide = (swiperEvent) => {
          const activeClass = 'secondary-navigation__swiper-slide--active';
          const slides = [...swiperEvent.slides];

          const activeSlideIndex = slides.findIndex((el) => el.classList.contains(activeClass));
          if (activeSlideIndex !== -1 && activeSlideIndex > 0) {
            const speed = activeSlideIndex * 220;
            swiperEvent.slideTo(activeSlideIndex, speed, true);
          }
        };

        const centerSlides = (swiperEvent) => {
          const shouldBeCentered = swiperEvent.isLocked || (swiperEvent.snapGrid && swiperEvent.snapGrid.length <= 1);
          if (swiperEvent.wrapperEl) {
            swiperEvent.wrapperEl.classList.toggle('secondary-navigation__swiper-wrapper--center', shouldBeCentered);
          }
        };

        this.swiper = new SwiperClass(this.swiperEl, {
          loop: false,
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 16,
          init: false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            0: {
              spaceBetween: 10
            },
            600: {
              spaceBetween: 12
            },
            900: {
              spaceBetween: 16
            }
          }
        });

        if (!this.keepPosition) {
          this.swiper.on('afterInit', scrollToActiveSlide);
        }
        
        this.swiper.on('init', centerSlides);
        this.swiper.on('afterInit', centerSlides);
        this.swiper.on('resize', centerSlides);
        this.swiper.on('update', centerSlides);
        
        this.swiper.init();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleLinkClick);
        this.swiper?.destroy(true, true);
      }
    },
  );
}
